<!-- App.vue -->
<template>
  <div id="app">

    <!-- 引入Header组件 -->
    <Header />

    <main>
      <!-- 路由视图 -->
      <router-view />
    </main>

    <!-- 其他组件，如Footer -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Footer,
    Header
  }
}
</script>

<style>
</style>